/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Templates_Ask_AdminInputs */



/**
* | output |
* | --- |
* | "Ask an administrator to create this agent." |
*
* @param {Agent_Templates_Ask_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_ask_admin = /** @type {((inputs?: Agent_Templates_Ask_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Ask_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitten Sie eine Administratorin oder einen Administrator, diesen Agenten anzulegen.")
	return /** @type {LocalizedString} */ ("Ask an administrator to create this agent.")
});